import * as React from 'react';

function SvgGdpr(props) {
  return (
    <svg width={98} height={40} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M6 0h86a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
          fill="#000"
        />
        <path d="M6 0h34v40H6a6 6 0 01-6-6V6a6 6 0 016-6z" fill="#2050E0" />
        <path
          d="M23.907 18.36l-4.317 4.41a.88.88 0 01-.546.23h-.372a.88.88 0 01-.546-.23l-2.033-2.082a.332.332 0 010-.461l.8-.816a.317.317 0 01.453 0l1.3 1.32a.317.317 0 00.452 0l3.56-3.635a.318.318 0 01.452-.002l.796.806a.33.33 0 01.001.46z"
          fill="#FFF"
        />
        <g fill="#F8D12E" fillRule="nonzero">
          <path d="M20 6l.454 1.468h1.468l-1.188.907.454 1.468L20 8.935l-1.187.908.453-1.468-1.188-.907h1.468zM20 30.157l.454 1.468h1.468l-1.188.907.454 1.468L20 33.093 18.813 34l.453-1.468-1.188-.907h1.468zM26.04 8.196l.453 1.468h1.468l-1.188.908.454 1.467-1.188-.907-1.187.907.453-1.467-1.187-.908h1.468zM30.922 24l.453 1.468h1.468l-1.188.908.454 1.467-1.187-.907-1.188.907.454-1.467L29 25.468h1.468zM32.079 18.078l.453 1.468H34l-1.188.907.454 1.469-1.187-.907-1.188.907.454-1.469-1.188-.907h1.468zM7.922 18.078l.453 1.468h1.468l-1.188.907.454 1.469-1.187-.907-1.188.907.454-1.469L6 19.546h1.468zM8.922 24l.453 1.468h1.468l-1.187.908.453 1.467-1.187-.907-1.188.907.454-1.467L7 25.468h1.468zM30.922 12l.453 1.468h1.468l-1.188.908.454 1.467-1.187-.907-1.188.907.454-1.467L29 13.468h1.468zM9.422 12l.453 1.468h1.468l-1.187.908.453 1.467-1.187-.907-1.188.907.454-1.467-1.188-.908h1.468zM27.137 29.059l.454 1.468h1.468l-1.188.907.454 1.468-1.188-.907-1.188.907.454-1.468-1.187-.907h1.468zM13.96 8.196l.454 1.468h1.468l-1.187.908.454 1.467-1.188-.907-1.188.907.454-1.467-1.188-.908h1.468zM12.863 29.059l.453 1.468h1.468l-1.187.907.453 1.468-1.187-.907-1.188.907.454-1.468-1.188-.907h1.468z" />
        </g>
        <path
          d="M47 15.628c0 2.843 2.178 4.627 4.854 4.627 1.694 0 2.998-.684 3.966-1.743V15.01h-4.33v1.918h2.058v.75c-.363.296-.995.537-1.694.537-1.466 0-2.501-1.126-2.501-2.588 0-1.462 1.035-2.59 2.501-2.59.847 0 1.533.47 1.896 1.06l1.936-1.019C55.027 11.966 53.817 11 51.854 11 49.178 11 47 12.784 47 15.628zm10.179 4.466v-8.946h3.764c2.824 0 4.854 1.69 4.854 4.466 0 2.777-2.03 4.48-4.84 4.48h-3.778zm2.312-2.012h1.452c1.574 0 2.488-1.14 2.488-2.468 0-1.381-.834-2.454-2.474-2.454H59.49v4.922zm7.463 2.012v-8.946h4.49c2.017 0 3.12 1.354 3.12 2.977 0 1.61-1.103 2.938-3.12 2.938h-2.178v3.031h-2.312zm5.257-5.982c0-.617-.457-1.02-1.076-1.02h-1.869v2.013h1.87c.618 0 1.075-.39 1.075-.993zm8.39 5.982l-1.506-3.031h-1.183v3.031h-2.313v-8.946h4.491c1.99 0 3.12 1.314 3.12 2.977 0 1.556-.955 2.388-1.789 2.683l1.829 3.286h-2.649zm.256-5.995c0-.618-.511-1.006-1.116-1.006h-1.829v2.012h1.829c.605 0 1.116-.39 1.116-1.006z"
          fill="#FFF"
        />
        <text
          fontFamily="HelveticaNeue-Bold, Helvetica Neue"
          fontSize={8}
          fontWeight="bold"
          letterSpacing={0.2}
          fill="#FFF"
        >
          <tspan x={47} y={30}>
            {'READY'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgGdpr;
